<template>
<Teleport to="body">
  <div class="fixed inset-0 z-50 flex justify-center bg-black/60">
    <div class="m-5 w-full md:w-8/12 lg:w-4/12 xl:w-3/12" @click.self="closeDialog(false)" >

      <div class="p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center">
        
        <div class="flex flex-col w-full text-black">
        
          <BlockUI :blocked="blocked">

            <div v-if="blocked" class="absolute inset-0 flex items-center justify-center z-50 bg-black/20">
              <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="5" fill="transparent" animationDuration=".5s" />
            </div>

            <div class="flex flex-col w-full rounded-t-md p-3 bg-[#243665]">
              <div>
                <span class="pi pi-lock w-6 h-6 text-white" />
              </div>
              <div class="font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis"> 
                {{ $t('titulo.recuperar.password') }}
              </div>
            </div>

            <Form>
              <div class="container p-4 text-left space-y-3">
                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
                  <div class="w-full px-2 md:w-1/1">
                    <label class="block mb-1">{{ $t('label.documento') }}</label>
                    <Field name="claveActual" v-slot="{ field }" v-model="dni">
                      <InputText v-bind="field" type="text" readonly="true" class="input-base input-success bg-gray-50" />
                    </Field>
                  </div>
                </div>
                <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
                  <div class="w-full px-2 md:w-1/1">
                    <label class="block mb-1">{{ $t('label.mail') }}</label>
                    <Field name="mail" v-slot="{ field }" v-model="mail">
                      <InputText v-bind="field" type="text" readonly="true" class="input-base input-success bg-gray-50" />
                    </Field>
                  </div>
                </div>
              </div>
            </Form>

            <div class="p-3 flex flex-col md:flex-row gap-2 justify-end w-full mt-2 bg-gray-100">
              <a @click="closeDialog(false)" class="cursor-pointer px-4 py-2 bg-transparent border-red-600 hover:bg-red-600 text-red-600 font-semibold hover:text-white border rounded-xl">
                <font-awesome-icon :icon="['fas', 'fa-xmark']" /> {{ $t('boton.cancelar') }}
              </a>
              <a @click="aplicarCambios" class="cursor-pointer px-4 py-2 bg-transparent border-[#243665] hover:bg-[#243665] text-[#243665] font-semibold hover:text-white border rounded-xl">
                <font-awesome-icon :icon="['fas', 'fa-check-double']" /> {{ $t('boton.enviar.mail') }}
              </a>
            </div>
          </BlockUI>


        </div>
      </div>

    </div>
  </div>
</Teleport>  

</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { Form, Field } from 'vee-validate';

import Swal from 'sweetalert2'
import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';
import ProgressSpinner from 'primevue/progressspinner';
import { Acreditado } from 'qreventos-suite/services';
import notificacionService from 'qreventos-suite/notificaciones';
import suiteConfig from '@/services/suite.config';

export default defineComponent({
  components: {
    InputText, BlockUI, ProgressSpinner,
    Field, Form
  },
  props: {
    acreditado: {
      type: Object as PropType<Acreditado>,
      required: true
    },
    closeFunction: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      blocked: false,
      dni: '',
      mail: ''
    };
  },
  methods: {
    closeDialog(aceptado: boolean = false) {
      if (this.closeFunction) {
        this.closeFunction(aceptado);
      }
    },
    async aplicarCambios() {
      try {
        this.blocked = true;

        const enviado:boolean = await notificacionService.sendMailAcreditado(suiteConfig.evento, this.acreditado.id, suiteConfig.TEMPLATE_MAIL_RECUPERAR_ACREDITADO);
        if (enviado) {
          this.closeDialog(true);
        }
      }
      catch (error) {
        this.blocked = false;
        Swal.fire({ title: "Error", text: 'Error [' + error + ']', icon: "error" });
      } finally {
        this.blocked = false;
      }
    }, 
  },
  async mounted() {
    document.body.style.overflow = "hidden";
    this.dni = this.acreditado.dni;
    this.mail = this.acreditado.mail;
  },
  unmounted() {
    document.body.style.overflow = "";
  }  
});
</script>